import {UserStateCriteria} from 'src/openapi/admin/models/UserStateCriteria';

export const REPORTS_SUB_TABS = {
    USAGE_REPORT: {
        name: 'usage-report',
        caption: 'Usage Report',
    },
    EXCEL_PLUGIN_USAGE_REPORT: {
        name: 'excel-plugin-usage-report',
        caption: 'Excel Plugin Usage Report',
    },
    USER_LIST: {
        name: 'user-list',
        caption: 'User List',
    },
    ASSOCIATED_BROWSERS: {
        name: 'associated-browsers',
        caption: 'User\'s Associated Browsers',
    },
    PASSWORD_SHARING: {
        name: 'password-sharing',
        caption: 'Password Sharing Report',
    },
};

export const USER_STATES_CAPTIONS: Record<UserStateCriteria, string> = {
    [UserStateCriteria.LICENSED]: 'Licensed Users (PB Licensed)',
    [UserStateCriteria.MOBILE]: 'Mobile Only Users (PB Mobile Only)',
    [UserStateCriteria.CRM_ONLY]: 'CRM Plugin Only Users',
    [UserStateCriteria.DISABLED]: 'Disabled (Newsletter)',
    [UserStateCriteria.NO_ACCESS]: 'No Access (Newsletter)',
    [UserStateCriteria.CREDIT_ALERTS_ONLY]: 'Credit Alerts Only Users',
};
